import { useEffect, useState } from 'react'

const BlogCell =({params})=> {
  const [subtitle, setSubTitle] = useState(params.subtitle);
  const [floors, setFloors] = useState(null);

  useEffect(()=> {
    if(params.specials && params.specials.nodes && params.specials.nodes[0]) setSubTitle(params.specials.nodes[0].name);
    if(params.floors && params.floors.nodes && params.specials.nodes[0]) setFloors(params.floors.nodes[0].name);
  }, [])


  return (
    <div className="event_item_info">
      <p className="title date_wrapper">
        {subtitle && <span className="type text-lg blog">{subtitle}</span>}
        {params.time && <span className="type text-lg blog">{params.time}</span>}
        {params.title}
        {floors && <span className="floor">{floors}</span>}
      </p>
    </div>
  )
}

export default BlogCell
